import type { ReactNode } from 'react'
import FloatingWhatsAppButton from './FloatingWhatsAppButton'
import OficinaWorld from './OficinaWorld'
import PageOpening, { type PageOpeningProps } from './PageOpening'
import SiteFooter from './SiteFooter'
import SiteHeader from './SiteHeader'
import './article.css'

/** Abertura completa sobre a paisagem, seguida da folha de leitura. */
export default function ArticleLayout({ children, ...opening }: PageOpeningProps & { children: ReactNode }) {
  return <div className="landing of-article-shell" id="topo">
    <OficinaWorld />
    <a className="skip-link" href="#conteudo">Pular para o conteúdo</a>
    <SiteHeader />
    <main id="conteudo" tabIndex={-1}>
      <PageOpening {...opening} />
      <div className="of-folha"><div className="of-article" id="leitura">{children}</div></div>
    </main>
    <FloatingWhatsAppButton />
    <SiteFooter />
  </div>
}
